import { CONSTANTS_GENERATION__value_range as CONSTANTS } from '@shared/constants/CONSTANTS_GENERATION__value_range';
import { ENUM__ml_asset_type } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_type';
import { MAP__serializable } from '@shared/dto/_base/MAP__serializable';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { DECORATOR__ui_without_component } from '../_base/_decorators/DECORATOR__ui_without_component';
import { ENUM__field_graph_interaction } from '../_base/_enums/ENUM__field_graph_interaction';
import { ENUM__field_connectable_type } from '../_base/_methods/ENUM__field_connectable_type';
import { FIELD__base } from '../_base/FIELD__base';
import { DECORATOR__class_serialization_tested } from '../_primitives/_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_primitives/_base/DECORATOR__class_serialization_tested_for_hash';
import { DECORATOR__field_not_linked } from '../_primitives/_base/DECORATOR__field_not_linked';
import { FIELD__list_lora } from '../_primitives/list/FIELD__list_lora';
import { FIELD_PRIMITIVE__int } from '../_primitives/number/FIELD_PRIMITIVE__int';
import { FIELD_PRIMITIVE__string_hash_ml_asset } from '../_primitives/string/hash/FIELD_PRIMITIVE__string_hash_ml_asset';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD__ml_asset_clip extends FIELD__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_ML_ASSET_CLIP;

  /*
   * STATIC METHODS
   */

  /*
   * FIELDS
   */
  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.TOKENIZER)
  model__tokenizer!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD_PRIMITIVE__string_hash_ml_asset.init_field_with_type(ENUM__ml_asset_type.TEXT_ENCODER)
  model__text_encoder!: FIELD_PRIMITIVE__string_hash_ml_asset;

  @FIELD_PRIMITIVE__int.init_as_field({
    value: CONSTANTS.CLIP_SKIP.min,
    value_range: CONSTANTS.CLIP_SKIP,
    values_allowed: CONSTANTS.CLIP_SKIP,
  })
  skipped_layers!: FIELD_PRIMITIVE__int;

  @FIELD__list_lora.init_as_field({ item_meta: MAP__serializable.from_object({ graph__interaction: ENUM__field_graph_interaction.HIDDEN }) })
  loras!: FIELD__list_lora;

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.ML_ASSET__CLIP;
  }

  field_connectable__value(graph: DTO_GRAPH__instance): string {
    return this.model__text_encoder.find_source(graph).field_connectable__value(graph);
  }

  @DECORATOR__ui_without_component
  post_init(): void {
    super.post_init();
  }

  @DECORATOR__field_not_linked()
  store__serialization_keys_list_white_for_hash(): string[] {
    let out: (keyof this)[] = [];

    out.push('model__text_encoder');
    out.push('model__tokenizer');
    out.push('skipped_layers');
    out.push('loras');

    return out as string[];
  }
}
